const translation = {
  custom: '사용자 정의',
  upgradeTip: {
    prefix: '플랜을 업그레이드하여',
    suffix: '브랜드를 사용자 정의하세요.',
  },
  webapp: {
    title: 'WebApp 브랜드 사용자 정의',
    removeBrand: 'Powered by Dify 삭제',
    changeLogo: 'Powered by 브랜드 이미지 변경',
    changeLogoTip: '최소 크기 40x40px의 SVG 또는 PNG 형식',
  },
  app: {
    title: '앱 헤더 브랜드 사용자 정의',
    changeLogoTip: '최소 크기 80x80px의 SVG 또는 PNG 형식',
  },
  upload: '업로드',
  uploading: '업로드 중',
  uploadedFail: '이미지 업로드 실패. 다시 업로드해 주세요.',
  change: '변경',
  apply: '적용',
  restore: '기본값으로 복원',
  customize: {
    contactUs: '문의하기',
    prefix: '앱 내 브랜드 로고를 사용자 정의하려면,',
    suffix: '엔터프라이즈 버전으로 업그레이드하세요.',
  },
}

export default translation
